import MainPanel from '~/js/components/wedding-styler/home/MainPanel';
import LoginPanel from '~/js/components/wedding-styler/dashboard/LoginPanel';
import VideoPopupPlay from '~/js/modules/video-popup';
import '~/js/modules/magnific-popup';

const { inspirationsData, countries }  = sandals_app.page;
const videoPopup = new VideoPopupPlay('home-inspirations-video');

ReactDOM.render(
    <MainPanel inspirationsData={inspirationsData}/>,
    document.getElementById('inspirations-container')
);

ReactDOM.render(
    <LoginPanel countries={countries} />,
    document.getElementById('login-modal')
);
